import { PathsV2 } from 'core/services/navigation/pathsV2';
import { CandidateProfileListPage } from 'pages-v2/candidates/list/CandidateProfileListPage';
import { AnalyseSourcingExternal } from 'pages-v2/analysis/sourcing-external/AnalyseSourcingExternal';
import { TalentPoolDetails } from 'pages-v2/candidates/list/TalentPoolDetails';
import { TalentPoolAddCandidatesPage } from 'pages-v2/candidates/list/TalentPoolAddCandidatesPage';
import { AnalyseCandidateProfileList } from 'pages-v2/candidates/list/AnalyseCandidateProfileList';
import { AnalyseTalentPoolDetails } from 'pages-v2/candidates/list/AnalyseTalentPoolDetails';
import { CandidateProfileDetailsPage } from 'pages-v2/candidates/details/CandidateProfileDetailsPage';
import { TalentPoolCandidateProfileDetailsPage } from 'pages-v2/candidates/details/TalentPoolCandidateProfileDetailsPage';
import { TalentPoolAddCandidatesCandidateProfileDetailsPage } from 'pages-v2/candidates/details/TalentPoolAddCandidatesCandidateProfileDetailsPage';
import { AnalyseCandidateProfileDetailsPage } from 'pages-v2/candidates/details/AnalyseCandidateProfileDetailsPage';
import { AnalyseTalentPoolCandidateProfileDetailsPage } from 'pages-v2/candidates/details/AnalyseTalentPoolCandidateProfileDetailsPage';
import { AnalyseSourcingInternalCampaignSetupWithCandidateProfiles } from 'pages-v2/analysis/sourcing-internal/AnalyseSourcingInternalCampaignSetupWithCandidateProfiles';
import { AnalyseSourcingInternalCampaignSetupWithCandidateBatch } from 'pages-v2/analysis/sourcing-internal/AnalyseSourcingInternalCampaignSetupWithCandidateBatch';

type RouteV2Option = {
  [K in keyof typeof PathsV2]: {
    component: React.ReactElement;
    type: 'analyse' | 'campaign' | 'internal-sourcing';
    disablePadding?: boolean;
  };
};

export const navigationRoutesV2: RouteV2Option = {
  // CANDIDATE PROFILE LIST
  CANDIDATE_PROFILE_LIST: {
    component: <CandidateProfileListPage />,
    type: 'internal-sourcing',
    disablePadding: true
  },
  TALENT_POOL_DETAILS: {
    component: <TalentPoolDetails />,
    type: 'internal-sourcing',
    disablePadding: true
  },
  TALENT_POOL_ADD_CANDIDATES: {
    component: <TalentPoolAddCandidatesPage />,
    type: 'internal-sourcing',
    disablePadding: true
  },
  ANALYSE_CANDIDATE_PROFILE_LIST: {
    component: <AnalyseCandidateProfileList />,
    type: 'analyse',
    disablePadding: true
  },
  ANALYSE_TALENT_POOL_DETAILS: {
    component: <AnalyseTalentPoolDetails />,
    type: 'analyse',
    disablePadding: true
  },
  // CANDIDATE PROFILE DETAILS
  CANDIDATE_PROFILE_DETAILS: {
    component: <CandidateProfileDetailsPage />,
    type: 'internal-sourcing'
  },
  TALENT_POOL_CANDIDATE_PROFILE_DETAILS: {
    component: <TalentPoolCandidateProfileDetailsPage />,
    type: 'internal-sourcing'
  },
  TALENT_POOL_ADD_CANDIDATES_CANDIDATE_PROFILE_DETAILS: {
    component: <TalentPoolAddCandidatesCandidateProfileDetailsPage />,
    type: 'internal-sourcing'
  },
  ANALYSE_CANDIDATE_PROFILE_DETAILS: {
    component: <AnalyseCandidateProfileDetailsPage />,
    type: 'analyse'
  },
  ANALYSE_TALENT_POOL_CANDIDATE_PROFILE_DETAILS: {
    component: <AnalyseTalentPoolCandidateProfileDetailsPage />,
    type: 'analyse'
  },
  // SOURCING EXTERNAL
  ANALYSE_SOURCE_EXTERNAL_CANDIDATES: {
    component: <AnalyseSourcingExternal />,
    type: 'analyse'
  },
  // SOURCING INTERNAL SETUP
  ANALYSE_SOURCE_INTERNAL_CAMPAIGN_SETUP_WITH_CANDIDATE_BATCH: {
    component: <AnalyseSourcingInternalCampaignSetupWithCandidateBatch />,
    type: 'analyse'
  },
  ANALYSE_SOURCE_INTERNAL_CAMPAIGN_SETUP_WITH_CANDIDATE_PROFILES: {
    component: <AnalyseSourcingInternalCampaignSetupWithCandidateProfiles />,
    type: 'analyse'
  }
};
